import { associateScorecardService } from 'config/api';
import actionTypes from './actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const getExpandedScorecard =
  (associatePin, filterType = 'QUARTER_TO_DATE', categories) =>
  async (dispatch) => {
    dispatch({ type: actionTypes.ASSOCIATE_EXP_SCORECARD_LOADING });

    const postBody = { filterType };

    try {
      const { data } = await associateScorecardService.post(`/v1/finalscorecard/${associatePin}/details`, postBody);
      dispatch({
        type: actionTypes.ASSOCIATE_EXP_SCORECARD_SUCCESS,
        payload: { data, categories },
      });
    } catch (error) {
      dispatch({ type: actionTypes.ASSOCIATE_EXP_SCORECARD_ERROR });
    }
  };
